import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select"
import { compactSelect, compactSelectError } from "../../../design/selectStyle";
import moment from "moment";

const PayrollInfo = ({validationErrors, payroll,setPayroll,handleChange,disabled,hasActions,isEdit }) => {
    const { t } = useTranslation("translations");
    
    const transferTypeOptions = [
      { value:"ONEBYONE", label: t("payRoll.oneByOne") },
      { value:"IN_BATCH", label: t("payRoll.inBatch"), isDisabled:true }
    ]
    
    const templateTypeOptions = [
      { value:"IBAN", label: t("payRoll.iban") },
      { value:"CIF", label: t("payRoll.cif"), isDisabled:true },
      { value:"ACCOUNT", label: t("payRoll.account"), isDisabled:true }
    ]
    
    const handleDescriptionChange=(value)=>{
      setPayroll(payroll=>{
        const salaryRecords = payroll.salaryRecords.map(record=>({
          ...record,
          description:value
        }))
        return {...payroll,description:value,salaryRecords}
      })
    }
    
    return (
      <div>
          <div className="d-flex justify-content-between header border-bottom w-full" style={{width:"100%"}}>
            <div>
              <label className="field-label ml-1">{t("payRoll.payrollInfo")}</label>
            </div>
        </div>
        <div className="row mx-1 mx-md-auto pt-2">
            <div className="col-12 col-md-6 py-0 px-2">
              <label className="field-label" htmlFor="transferType">{t("payRoll.transferType")}</label>
              <Select
                styles={validationErrors?.transferType?compactSelectError :compactSelect}
                options={transferTypeOptions}
                value={transferTypeOptions.find(opt=>opt.value==payroll.transferType)}
                isSearchable={true}
                onChange={(type) =>
                  handleChange("transferType", type.value)
                }
                name="transferType"
                isDisabled={disabled}
              />
            </div>
            <div className="col-12 col-md-6 py-0 px-2">
              <label className="field-label" htmlFor="templateType">{t("payRoll.templateType")}</label>
              <Select
                styles={validationErrors?.transferType?compactSelectError :compactSelect}
                options={templateTypeOptions}
                value={templateTypeOptions.find(opt=>opt.value==payroll.templateType)}
                isSearchable={true}
                onChange={(type) =>
                  handleChange("templateType", type.value)
                }
                name="templateType"
                isDisabled={disabled}
              />
            </div>
          {/* <div className="col-12 col-md-6 py-0 px-2">
              <label className="field-label" htmlFor="transactionId">{t("payRoll.transactionId")}</label>
              <input
                type="text"
                name="transactionId"
                className="form-control form-control-sm"
                value={payroll?.transactionId ?? ""}
                onChange={handleChange}
                disabled={!isEdit || disabled}
              />
          </div>
          <div className="col-12 col-md-6 py-0 px-2">
              <label className="field-label" htmlFor="transactionDate">{t("payRoll.transactionDate")}</label>
              <input
                type="text"
                name="transactionDate"
                id="transactionDate"
                className="form-control form-control-sm"
                value={payroll?.transactionDate ? moment(payroll.transactionDate).format("DD/MM/YYYY") : ""}
                onChange={handleChange}
                disabled={!isEdit || disabled}
              />
          </div> */}
          <div className="col-12 col-md-12 py-0 px-2">
                <label className="field-label" htmlFor="description">{t("payRoll.description")}</label>
                <textarea
                  row={2}
                  type="text"
                  name="description"
                  className="form-control form-control-sm"
                  value={payroll?.description ?? ""}
                  onChange={(e)=>handleDescriptionChange(e.target.value)}
                  disabled={disabled}
                />
          </div>
        </div>
      </div>
    );
};

export default PayrollInfo;